
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import ControlDrag from './control-drag'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "controldrag"
    }}>{`ControlDrag`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Controls`}</p>
    <hr />
    <h2 {...{
      "id": "drag"
    }}>{`Drag`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For manipulating the position of media or content, either by peripheral input or drag gesture.`}</p>
    <Playground __position={1} __code={'<ControlDrag />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDrag
    }} mdxType="Playground">
  <ControlDrag mdxType="ControlDrag" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={2} __code={'<ControlDrag disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDrag
    }} mdxType="Playground">
  <ControlDrag disabled mdxType="ControlDrag" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "drag-inverse"
    }}>{`Drag (inverse)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For manipulating the position of media or content, either by peripheral input or drag gesture.`}</p>
    <Playground __position={4} __code={'<ControlDrag inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDrag
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlDrag inverse mdxType="ControlDrag" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={5} __code={'<ControlDrag inverse disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDrag
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlDrag inverse disabled mdxType="ControlDrag" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "drag-horizontal"
    }}>{`Drag (horizontal)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For manipulating the position of media or content, either by peripheral input or drag gesture.`}</p>
    <Playground __position={7} __code={'<ControlDrag horizontal />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDrag
    }} mdxType="Playground">
  <ControlDrag horizontal mdxType="ControlDrag" />
    </Playground>
    <Playground __position={8} __code={'<ControlDrag horizontal disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDrag
    }} mdxType="Playground">
  <ControlDrag horizontal disabled mdxType="ControlDrag" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "drag-horizontal-inverse"
    }}>{`Drag (horizontal, inverse)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For manipulating the position of media or content, either by peripheral input or drag gesture.`}</p>
    <Playground __position={10} __code={'<ControlDrag horizontal inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDrag
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlDrag horizontal inverse mdxType="ControlDrag" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={11} __code={'<ControlDrag horizontal inverse disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDrag
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlDrag horizontal inverse disabled mdxType="ControlDrag" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={ControlDrag} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;